'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../../../utils/helpers');

var _adSettings = require('../../../../utils/ads/adSettings.json');

var _adSettings2 = _interopRequireDefault(_adSettings);

var _adTypes = require('../../../../utils/ads/ad-types');

var AdTypes = _interopRequireWildcard(_adTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FW Ad StandAlone component
 * Allows these props: (adType, width, height)
 * @access public
 * @extends {React.Component}
 */
var FWAdStandAlone = function (_React$Component) {
  (0, _inherits3.default)(FWAdStandAlone, _React$Component);
  (0, _createClass3.default)(FWAdStandAlone, null, [{
    key: 'getIframeSrc',

    /**
     * Helper to build ad iframe src
     * @param {string} adType type of ad to be displayed
     * @param {Object} pageData page api data
     * @returns {XML}
     */
    value: function getIframeSrc(adType, pageData) {
      if (typeof AdTypes[adType] !== 'undefined' && (0, _helpers.exists)(pageData) && (0, _helpers.hasKey)(pageData, 'data.adSettings.freewheel.sectionId')) {
        var env = 'production';
        if ((0, _helpers.exists)(pageData.env)) {
          env = pageData.env;
        }
        if ((0, _helpers.exists)(pageData.data.adSettings.freewheel[env])) {
          // The advertisement env can be overridden using the query string params "mode" or "debug"
          if ((0, _helpers.hasKey)(pageData, 'requestParams')) {
            if (pageData.requestParams.mode === 'test' || pageData.requestParams.debug === 'true') {
              env = 'test';
            } else if (pageData.requestParams.mode === 'prod') {
              env = 'production';
            }
          }

          var device = 'mobile';
          if ((0, _helpers.exists)(pageData.device)) {
            device = pageData.device;
          }

          var sectionId = pageData.data.adSettings.freewheel.sectionId;
          var adValue = pageData.data.adSettings.freewheel.adValue;

          var settings = pageData.data.adSettings.freewheel[env];
          var adTypeSettings = _adSettings2.default[AdTypes[adType]];
          var printOptions = '';
          if (Array.isArray(adTypeSettings) && adTypeSettings.length) {
            printOptions = adTypeSettings.join('&');
          }
          return (settings.host + '/ad/g/1?\n            nw=' + settings.networkCode + '&\n            prof=' + settings.linkTag2Profile + '&\n            ssid=' + device.substring(0, 1) + '.' + sectionId + '&\n            resp=ad;\n            module=ContentTypeTransform;\n            adType=text/javascript;\n            tag=' + adValue + '&\n            ' + printOptions).replace(/ /g, '');
        }
      }
      return null;
    }

    /**
     * FW Ad StandAlone generator
     * @constructor
     */

  }]);

  function FWAdStandAlone() {
    (0, _classCallCheck3.default)(this, FWAdStandAlone);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FWAdStandAlone.__proto__ || (0, _getPrototypeOf2.default)(FWAdStandAlone)).call(this));

    _this.state = {
      iframeSrc: null
    };
    return _this;
  }

  /**
   * Using didMount to be ensure this fw ad call
   * is made after DFP calls that rely on didMount too
   */


  (0, _createClass3.default)(FWAdStandAlone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Disabling to allow code on client only
      /* eslint-disable react/no-did-mount-set-state */
      this.setState({
        iframeSrc: FWAdStandAlone.getIframeSrc(this.props.adType, this.props.pageData)
      });
    }

    /**
     * On render it returns the ad iframe on client only
     * @returns {JSX}
     */

  }, {
    key: 'render',
    value: function render() {
      if (this.state.iframeSrc) {
        var iframeHtml = '<iframe\n          style="width:' + this.props.width + 'px;height:' + this.props.height + 'px;overflow:hidden;border:none;"\n          scrolling="no"\n          src="' + this.state.iframeSrc + '"\n          />';
        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: { __html: iframeHtml } // eslint-disable-line react/no-danger
        });
      }
      return null;
    }
  }]);
  return FWAdStandAlone;
}(_react2.default.Component);

/**
 * propTypes
 * @type {{adSetting: *}}
 */


exports.default = FWAdStandAlone;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/ads/fw/StandAlone/FWAdStandAlone.js
// module id = 282
// module chunks = 35783957827783